import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";
import { buildClientHistoryListRequest } from "./clientHistoryRequest";

const API_URL = config.API_URL;
const pendingProfileSyncKeys = new Map();

const generatedKey = () => {
  if (typeof globalThis.crypto?.randomUUID === "function") return globalThis.crypto.randomUUID();
  return `client-form-sync-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const view = (values) => {
  const request = buildClientHistoryListRequest("afterlogin/client/clientAnswerList", values || {});
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};

const profileSync = (values = {}) => {
  const body = {
    client_id: values.client_id,
    id: values.id,
    decisions: Array.isArray(values.decisions) ? values.decisions.map(({ field, action }) => ({ field, action })) : [],
    revision: values.revision,
  };
  const suppliedKey = typeof values.idempotency_key === "string" ? values.idempotency_key.trim() : "";
  const fingerprint = JSON.stringify(body);
  const key = suppliedKey || pendingProfileSyncKeys.get(fingerprint) || generatedKey();
  if (!suppliedKey) pendingProfileSyncKeys.set(fingerprint, key);
  const request = axios.post(`${API_URL}afterlogin/client/clientAnswerProfileSync`, body, {
    headers: { ...authHeader(), "Idempotency-Key": key },
  });
  if (!request || typeof request.then !== "function") return request;
  return request.then((response) => {
    if (!suppliedKey) pendingProfileSyncKeys.delete(fingerprint);
    return response;
  });
};

const signatureContent = ({ clientId, submissionId, answerId, signal }) =>
  axios.get(`${API_URL}afterlogin/client/${clientId}/forms/${submissionId}/answers/${answerId}/content`, {
    headers: authHeader(), responseType: "blob", signal,
  });

const clientformApiController = {
  signatureContent,
  view,
  profileSync,
};
export default clientformApiController;
